// @ts-ignore
export const all = (state) => state.all;
export const one = (state) => state.one;
